import { HttpClient } from "@angular/common/http";
import { AfterViewInit, ChangeDetectorRef, Component, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild, ViewEncapsulation } from "@angular/core";
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
  AbstractControl,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { DropDownListComponent } from "@syncfusion/ej2-angular-dropdowns";
import { ExpandEventArgs } from '@syncfusion/ej2-angular-navigations';
import {
  DialogComponent,
  TooltipComponent,
} from "@syncfusion/ej2-angular-popups";
import { closest, EmitType } from "@syncfusion/ej2-base";
import { UUID } from "angular2-uuid";
import { ToastrService } from "ngx-toastr";
import { Subject, Subscription, of, forkJoin } from "rxjs";
import { fadeInOut } from "../../shared/helpers/animations";
import {
  IEntity,
  IER,
  IErRevisionHistory,
  IEstablishment,
  IImporter,
  ILLCompany,
  ILLCustomerCompaniesByTypeWrapper,
  ILLBusinessCategory,
  ILLEstablishment,
  ILLGenericKeys,
  ISplValidation,
  ISSDPConctact,
} from "../../shared/models/index";
import { ERFormService } from "../../shared/services/er-form-service";
import {
  AuthorizationService,
  CompanyContactService,
  StorageManagerService,
  LLFormService,
} from "../../shared/services/index";
import { Utilities } from "../../shared/services/utilities";
import {
  ErrorMessagesComponent,
  ContactComponent,
  DeleteButtonComponent,
} from "../index";
import { DatePipe } from "@angular/common";
import { CompanyDetailsComponent } from "../company-details/company-details.component";
import { RefdataService } from "../../shared/services/refdata.service";
import { catchError } from "rxjs/operators";

@Component({
    selector: "app-er-form",
    templateUrl: "./er-form.component.html",
    styleUrls: ["./er-form.component.scss"],
    encapsulation: ViewEncapsulation.Emulated,
    animations: [fadeInOut],
    standalone: false
})
export class ERFormComponent
  implements OnInit, AfterViewInit, OnDestroy, OnChanges
{
  @ViewChild("buildModalDialog") buildModalDialog: DialogComponent;
  @ViewChild("revHistoryDialog") revHistoryDialog: DialogComponent;
  @ViewChild("busOpsDialog") busOpsDialog: DialogComponent;
  @ViewChild("registrantDdw") registrantDdw: DropDownListComponent;
  @ViewChild("estabCompanyDdw") estabCompanyDdw: DropDownListComponent;
  @ViewChild("companyDialog") public companyDialog: DialogComponent;
  @ViewChild("companyDetails")
  public companyDetailsComponent: CompanyDetailsComponent;
  @ViewChild("contactDialog") public contactDialog: DialogComponent;
  @ViewChild("contact") public contactComponent: ContactComponent;
  @ViewChild("deleteButton") deleteButton: DeleteButtonComponent;

  errorMessagesComponent: ErrorMessagesComponent;
  position: object = { X: "center", Y: "center" };
  modalWidth = "30%";
  modalHeight = "auto";
  animationSettings: Object = { effect: "Zoom" };
  isModal = true;

  ddwFields: Object = { text: "name", value: "id" };
  splSubmissionTypeFields: Object = { text: "labelAndCode", value: "id" };
  public ddwHeight = "220px";
  public ddwWidth = "450px";
  ddwWaterMark = "Select One";
  splValidationMessages: ISplValidation = new ISplValidation();
  showValidationMessages: boolean;
  pageLoading = false;
  // Button Spinners
  buildLoading = false;
  validateLoading = false;
  saveLoading = false;
  updatedVersion: string;

  erRevisionId: string;
  formData: any;
  formDetailData = new IER();
  bHasPermission = false;
  hasDeletePermission: boolean = false;
  formName: string;
  allLOV: any[] = [];
  splSubmissionTypeDdwDS: any[] = [];
  erRevisions: IErRevisionHistory[] = [];
  revisionCurrentRevision: IErRevisionHistory;
  registrantCompany: ILLCompany;
  registrantCompanies: ILLCompany[] = [];
  estabUsAgentCompanies: ILLCompany[] = [];
  estabImporterCompanies: ILLCompany[] = [];
  registrantCompaniesDdwDS: any[] = [];
  registrantContact = {};
  estabCompaniesDdwDS = [];
  estabUsAgentCompaniesDdwDS = [];
  estabImporterCompaniesDdwDS = [];
  erData: IER;
  estabCompanies: ILLEstablishment[] = [];
  businessOperations: ILLGenericKeys[] = [];
  establishments: IEstablishment[] = [];
  rules = { setId: { required: true } };

  iconTypeCompany = true;

  sub: Subscription;
  confirmDialogSelection$: Subject<boolean> = new Subject<boolean>();
  setId: string;
  status: string;
  splVersion: string;
  lastModifiedBy: string;
  lastModifiedDate: string;
  splSubmissionTypeMissing: boolean;
  revisionDateMissing = true;
  current: boolean;
  versionToDisplay: any;
  businessCategoryModel: object;
  erForm: UntypedFormGroup;
  registrantCompanyRevisionId: any;
  dunsNumber: string;
  setIdModel: object;
  revHistoryVisible = false;
  buildModalDialogVisible = false;
  public type = "Push";
  public enablePersistence = false;
  public clickEventArgs: Event;
  countries: IEntity[] = [];
  regions: IEntity[] = [];

  public hidden: Boolean = false;
  buildERComplete = false;

  parentComponent: any;
  customerGuid: string;
  companyData: any;

  // eslint-disable-next-line @typescript-eslint/member-ordering
  formErrors = {
    splServiceTypeId: "",
    registrantCompanyRevisionId: "",
    missingCompanyRevisionId: "",
    effectiveTime: "",
  };

  // eslint-disable-next-line @typescript-eslint/member-ordering
  validationMessages = {
    splServiceTypeId: {
      required: "SPL Service type is required",
    },
    registrantCompanyRevisionId: {
      required: "Registrant company is required",
    },
    missingCompanyRevisionId: {
      required: "Missing company details",
    },
    effectiveTime: {
      required: "Build SPL requires SPL revision date",
    },
  };

  companyDetailUrl: string;
  registrantContactRevisionId: any;
  contactDetailUrl: string;
  ignoreWarnings = false;
  errorMessage: string;
  // estabCompanyRevisionId: number;
  estabCompany: ILLCompany;
  estabContactRevisionId: any;
  busOpsDialogVisible = false;
  companyName: any;
  splServiceTypeId: any;
  estabUSAgentCompanyRevisionId: any;
  estabImporterCompanyRevisionId: any;
  businessCategoryId: any;
  usBasedCode: string;
  usUMICode: string;
  contacts: any[] = [];
  locallySavedLatestContacts: any[] = [];
  isSaving = false;
  modalCompanyType: string;
  modifiedCompanyOldRevisionId: number;
  estabIndex: any;
  importerIndex: any;
  submitted = false;
  isDraftMode: boolean = false;
  invalidSplVersion = false;
  ddwSubmissionTypePreviousData: any;
  isEditMode: boolean = false;
  canCreateCompany: boolean = false;

  @ViewChild("tooltipObj") public tooltipObj: TooltipComponent;
  restrictedSplSubmissionType = false;
  @ViewChild("confirmDialog")
  public confirmDialog: DialogComponent;
  @ViewChild("ddwSubmissionType")
  public ddwSubmissionType: DropDownListComponent;

  splSubmissionTypeName: any;
  dateFormat: string;

  confirmDlgBtnClickYes: EmitType<object> = () => {
    this.confirmDialog.hide();
  };

  confirmDlgBtnClickNo: EmitType<object> = () => {
    if (this.ddwSubmissionType) {
      this.ddwSubmissionType.value = this.ddwSubmissionTypePreviousData
        ? this.ddwSubmissionTypePreviousData.id
        : 0;
    }

    this.confirmDialog.hide();
  };

  // eslint-disable-next-line @typescript-eslint/member-ordering
  confirmDlgButtons: Object[] = [
    {
      click: this.confirmDlgBtnClickNo.bind(this),
      buttonModel: { content: "Cancel" },
    },
    {
      click: this.confirmDlgBtnClickYes.bind(this),
      buttonModel: { content: "Continue", isPrimary: true },
    },
  ];

  constructor(
    private fb: UntypedFormBuilder,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private erService: ERFormService,
    public datepipe: DatePipe,
    private llService: LLFormService,
    private toastr: ToastrService,
    private storageManagerService: StorageManagerService,
    private authorizationService: AuthorizationService,
    private utilService: Utilities,
    private companyService: CompanyContactService,
    private cdRef: ChangeDetectorRef,
    private http: HttpClient,
    private refDataService: RefdataService
  ) {}

  get estabFormGroup(): UntypedFormGroup {
    return this.fb.group({
      establishmentId: [0],
      establishmenName: [""],
      sequence: [0],
      establishmentCompany: [
        "",
        { validators: [Validators.required], updateOn: "blur" },
      ],
      estabCompanyRevisionId: [0],
      establishmentContact: [""],
      usAgentCompany: [""],
      usAgentCompanyRevisionId: [0],
      usAgentContact: [""],
      importers: this.fb.array([this.importerFormGroup]),
    });
  }

  get importerFormGroup(): UntypedFormGroup {
    return this.fb.group({
      importerId: [0],
      sequence: [0],
      importerCompanyRevisionId: [0],
      importerCompany: [""],
      importerContact: [""],
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const property in changes) {
      if (
        changes[property].currentValue ||
        changes[property].currentValue === "" ||
        changes[property].currentValue === 0
      ) {
        switch (property) {
          case "registrantCompanyRevisionId":
            this.erForm.patchValue({
              registrantCompanyRevisionId: changes[property].currentValue,
            });
            break;
          case "splServiceTypeId":
            this.erForm.patchValue({
              splServiceTypeId: changes[property].currentValue,
            });
            break;
        }
      }
    }
  }

  ngOnInit() {
    this.erForm = this.fb.group({
      erId: [0],
      erRevisionId: [0],
      formName: [""],
      majorRevision: [0],
      splTitle: [""],
      splServiceTypeId: [
        0,
        { validators: [Validators.required], updateOn: "blur" },
      ],
      splServiceType: [""],
      setId: [""],
      dunsNumber: [""],
      versionNumber: [""],
      effectiveTime: [""],
      // busCategory: [new ILLBusinessCategory()],
      ipeBusinessCategory: [""],
      splVersion: [0],
      registrantCompanyRevisionId: [
        0,
        { validators: [Validators.required], updateOn: "blur" },
      ],
      registrantCompany: [""],
      registrantContact: [""],
      registrantContactRevisionId: [0],
      establishmentCompanyId: [0],
      establishments: this.fb.array([this.estabFormGroup]),
    });
    // Initialiaztion
    this.initParams();

    // set focus on the invisible div so the first tab will bring it to the "Skip to Main Navigation" button because it must be the first tab target on the page (508 Compliance)
    this.initTabIndex();

    // Populate the controls with previously saved data
    this.populateDataFromResolver();

    // Validation error handling
    this.initValidation();

    // Watches changes on the entire form
    this.sub = this.erForm.valueChanges.subscribe((data) => {
      this.logValidationErrors(this.erForm);
    });

    this.erForm.markAsPristine();

    // Fix for footer spacing issues
    document
      .getElementsByTagName("footer")[0]
      .classList.add("footer-spacing-fix");

    this.dateFormat = Utilities.getLocaleDateString();
  }

  initTabIndex() {
    (document.activeElement as HTMLElement).blur();

    const main = document.getElementById('firstDiv');

    if (main) {
      main.focus();
    }
  }

  setERForm(formData: any) {
    if (formData) {
      const registrantCompany = formData.registrantCompany || new ILLCompany();
      const registrantContact = formData.registrantContact || new ISSDPConctact();
      const splServiceType = formData.splServiceType || new ILLGenericKeys();

      this.erForm.patchValue({
        erId: formData.erId,
        erRevisionId: formData.erRevisionId,
        formName: registrantCompany.companyName || "",
        majorRevision: formData.majorRevision,
        splTitle: formData.companyName,
        splServiceTypeId: splServiceType.id
          ? +splServiceType.id
          : "",
        splServiceType: splServiceType,
        setId: formData.setId,
        dunsNumber: formData.dunsNumber,
        versionNumber: formData.versionNumber,
        effectiveTime: formData.effectiveTime,
        // busCategory: formData.busCategory,
        // businessCategoryId: formData.busCategory ? (formData.busCategory.categoryId ? +formData.busCategory.categoryId : null) : null,
        ipeBusinessCategory: this.businessCategoryId,
        splVersion: formData.splVersion,
        registrantCompany: registrantCompany,
        registrantCompanyRevisionId:
          registrantCompany.companyRevisionId || 0,
        registrantCompanyId: registrantCompany.companyId || 0,
        registrantContact: registrantContact,
        registrantContactRevisionId:
          registrantContact.contactRevisionId || 0,
      });

      this.erForm.setControl(
        "establishments",
        this.setEstabForm(formData.establishments)
      );
    }
  }

  setEstabForm(estabs: IEstablishment[]): UntypedFormArray {
    const formArray = new UntypedFormArray([]);

    if (this.asArray(estabs).length > 0) {
      this.asArray(estabs).forEach((e, i) => {
        const establishmentCompany = e && e.establishmentCompany;
        const establishmentContact = e && e.establishmentContact ? e.establishmentContact : new ISSDPConctact();
        const usAgentCompany = e && e.usAgentCompany;
        const usAgentContact = e && e.usAgentContact ? e.usAgentContact : new ISSDPConctact();

        formArray.push(
          establishmentCompany
            ? this.fb.group({
                establishmentId: e.establishmentId || 0,
                establishmenName: e.establishmentName || "",
                sequence: e.sequence || 0,
                establishmentCompany: establishmentCompany,
                estabCompanyRevisionId:
                  establishmentCompany.companyRevisionId || 0,
                establishmentContact: establishmentContact,
                usAgentCompany: usAgentCompany ? usAgentCompany : "",
                usAgentCompanyRevisionId: usAgentCompany
                  ? usAgentCompany.companyRevisionId || 0
                  : "",
                usAgentContact: usAgentContact,
                importers: this.addImporters(e && e.importers),
              })
            : this.fb.group({
                establishmentId: [0],
                establishmenName: [""],
                sequence: [0],
                establishmentCompany: [""],
                estabCompanyRevisionId: [0],
                establishmentContact: [""],
                usAgentCompany: [""],
                usAgentCompanyRevisionId: [0],
                usAgentContact: [""],
                importers: this.addImporters([]),
              })
        );
      });
    } else {
      formArray.push(
        this.fb.group({
          establishmentId: [0],
          establishmenName: [""],
          sequence: [0],
          establishmentCompany: [""],
          estabCompanyRevisionId: [0],
          establishmentContact: [""],
          usAgentCompany: [""],
          usAgentCompanyRevisionId: [0],
          usAgentCompanyId: [""],
          usAgentContact: [""],
          importers: this.addImporters([]),
        })
      );
    }

    return formArray;
  }

  private setEstabControl(formArray?: UntypedFormArray): void {
    const scrollPos = window.scrollY + 100;
    this.erForm.setControl(
      'establishments',
      formArray ?? this.setEstabForm(this.formDetailData.establishments)
    );
    // Force synchronous change detection so the DOM is updated before the browser paints,
    // then restore scroll in the same JS task to prevent any visible jump.
    this.cdRef.detectChanges();
    window.scrollTo({ top: scrollPos, behavior: 'instant' as ScrollBehavior });
  }

  addImporters(importers: any): UntypedFormArray {
    const formArray = new UntypedFormArray([]);

    if (this.asArray(importers).length > 0) {
      this.asArray(importers).forEach((e, i) => {
        const importerCompany = e && e.importerCompany;
        const importerContact = e && e.importerContact ? e.importerContact : new ISSDPConctact();

        formArray.push(
          importerCompany
            ? this.fb.group({
                importerId: e.importerId || 0,
                sequence: e.sequence || 0,
                importerCompanyRevisionId: importerCompany.companyRevisionId || 0,
                importerCompany: importerCompany,
                importerContact: importerContact,
              })
            : this.fb.group({
                importerId: [0],
                sequence: [0],
                importerCompanyRevisionId: [0],
                importerCompany: [""],
                importerContact: [""],
              })
        );
      });
    } else {
      formArray.push(
        this.fb.group({
          importerId: [0],
          sequence: [0],
          importerCompanyRevisionId: [0],
          importerCompany: [""],
          importerContact: [""],
        })
      );
    }

    return formArray;
  }

  get estabs(): UntypedFormArray {
    return this.erForm.get("establishments") as UntypedFormArray;
  }

  get estabFormControls() {
    return this.estabs.controls;
  }

  importersArray(estabIndex: number): UntypedFormArray {
    const arr = this.estabs.at(estabIndex).get("importers") as UntypedFormArray;
    return arr;
  }

  private asArray(value: any): any[] {
    return Array.isArray(value) ? value : [];
  }

  private toPositiveNumber(value: any): number {
    const numberValue = Number(value);
    return !isNaN(numberValue) && numberValue > 0 ? numberValue : 0;
  }

  private findByNumericId(list: any[], id: any, fieldName = "id"): any {
    const numericId = this.toPositiveNumber(id);
    if (!numericId) {
      return null;
    }

    return this.asArray(list).find(
      (item) => this.toPositiveNumber(item && item[fieldName]) === numericId
    );
  }

  private resolveCountry(countryOrId: any): any {
    if (!countryOrId) {
      return null;
    }

    const countries = this.asArray(this.countries);
    const countryObject = typeof countryOrId === "object" ? countryOrId : null;
    const countryId = countryObject
      ? this.toPositiveNumber(countryObject.id)
      : this.toPositiveNumber(countryOrId);

    const countryById = this.findByNumericId(countries, countryId);
    if (countryById) {
      return countryById;
    }

    if (!countryObject) {
      return null;
    }

    const codeCandidate = (
      countryObject.code ||
      this.getCode(countryObject.label) ||
      this.getCode(countryObject.name) ||
      ""
    )
      .toString()
      .trim()
      .toLowerCase();

    if (codeCandidate) {
      const countryByCode = countries.find(
        (country) => (country && country.code ? country.code.toString().trim().toLowerCase() : "") === codeCandidate
      );
      if (countryByCode) {
        return countryByCode;
      }
    }

    const labelCandidate = (countryObject.label || countryObject.name || "")
      .toString()
      .trim()
      .toLowerCase();

    if (labelCandidate) {
      return countries.find(
        (country) =>
          (country && country.label ? country.label.toString().trim().toLowerCase() : "") === labelCandidate ||
          (country && country.name ? country.name.toString().trim().toLowerCase() : "") === labelCandidate
      );
    }

    return null;
  }

  isForeignCountry(countryOrId: any): boolean {
    const country = this.resolveCountry(countryOrId);
    const countryId = this.toPositiveNumber(country && country.id);
    const usaId = this.toPositiveNumber(this.usBasedCode);
    const umiId = this.toPositiveNumber(this.usUMICode);

    return !!countryId && countryId !== usaId && countryId !== umiId;
  }

  private getFirstContact(company: any): ISSDPConctact {
    return this.asArray(company && company.contacts)[0] || new ISSDPConctact();
  }

  ngAfterViewInit() {
    this.cdRef.detectChanges();
  }

  public onClick(e) {
    this.clickEventArgs = e.originalEvent;
  }

  // set the ignore warning flag for building SPL
  ignoreWarningsToggle() {
    this.ignoreWarnings = !this.ignoreWarnings;
  }

  initParams() {
    this.parentComponent = this;

    this.utilService.toggleClientDropdownState(true);

    this.formData = this.activatedRoute.snapshot.data["formData"];
    this.erRevisionId = this.activatedRoute.snapshot.params["revisionId"];

    const parsedRevisionId = parseInt(this.erRevisionId);
    this.isEditMode = !isNaN(parsedRevisionId) && parsedRevisionId > 0;

    this.checkUserPermission();

    const currentCustomerStr =
      this.storageManagerService.read("currentCustomer");

    if (currentCustomerStr) {
      const currentCustomer =
        typeof currentCustomerStr === "object"
          ? currentCustomerStr
          : JSON.parse(currentCustomerStr);
      if (currentCustomer) {
        this.customerGuid = currentCustomer.customerGuid;
      }
    }
  }

  checkUserPermission() {
    if (this.authorizationService.hasPermission("SSDP.CanWriteERForm")) {
      this.bHasPermission = true;
    }

    if (this.authorizationService.hasPermission("SSDP.CanDeleteERForm")) {
      this.hasDeletePermission = true;
    }

    if (this.authorizationService.hasPermission("SSDP.CanWriteCompany")) {
      this.canCreateCompany = true;
    }
  }

  saveERForm(
    isDraft: boolean,
    isValidate: boolean,
    isBuild: boolean,
    isIngestion: boolean
  ) {
    this.submitted = true;
    this.isDraftMode = isDraft;

    const duplicateCompanies = this.isDuplicateCompanies(
      this.erForm.value.establishments
    );

    if (!duplicateCompanies) {
      this.f.effectiveTime.clearValidators();
      this.f.effectiveTime.updateValueAndValidity();

      // Establishment details not mandatory, while  save as draft
      if (this.formErrors.missingCompanyRevisionId && !isDraft) {
        this.erForm.setErrors({ invalid: true });
      }

      // stop here if form is invalid
      if (this.erForm.invalid) {
        this.setFormErrors();
        return;
      }

      const modifiedByUser = this.storageManagerService.read("userData").name;

      if (this.erForm.touched || this.erForm.dirty) {
        this.prepareDataForSave(this.erForm.value);

        this.sub = this.erService
          .saveERForm(this.erData, modifiedByUser, isDraft, isIngestion)
          .subscribe(
            (response) => {
              this.pageLoading = false;
              this.saveLoading = false;
              if (response?.isSuccess) {
                this.toastr.success(`${response?.message}`);
                this.pageLoading = false;
                this.saveLoading = false;
                this.buildLoading = false;
                this.isDraftMode = false; //reset isDraftMode to false, to enable "Missing company.." validation, in case "Validate/Build SPL" button(s) clicked immediately after this.

                this.isSaving = true;

                this.router.navigate([
                  `/er-form/${response?.data?.erRevisionId}`,
                ]);
              } else {
                this.pageLoading = false;
                this.saveLoading = false;
                this.buildLoading = false;
                this.errorMessage =
                  response && response.message
                    ? response.message
                    : "Form creation failed!";
                this.toastr.error(this.errorMessage);
              }
            },
            (error) => {
              this.pageLoading = false;
              this.saveLoading = false;
              this.buildLoading = false;
              this.toastr.error(
                error.errorMessage ? error.errorMessage : error
              );
            }
          );
        this.erForm.markAsPristine();
      } else {
        this.pageLoading = false;
        this.saveLoading = false;
        this.buildLoading = false;
        this.toastr.warning("No changes to save.");
      }
    } else {
      this.pageLoading = false;
      this.saveLoading = false;
      this.buildLoading = false;
      this.toastr.error("Duplicate companies are not allowed");
    }
  }

  setFormErrors(sentFromBuildSpl?: boolean) {
    if (!this.f.splServiceTypeId.value) {
      this.formErrors.splServiceTypeId =
        this.validationMessages.splServiceTypeId.required;
    }

    if (!this.f.registrantCompanyRevisionId.value) {
      this.formErrors.registrantCompanyRevisionId =
        this.validationMessages.registrantCompanyRevisionId.required;
    }

    if (!this.f.effectiveTime.value) {
      this.formErrors.effectiveTime =
        this.validationMessages.effectiveTime.required;
    }
  }

  getClass(field) {
    let retVal;
    let valid: boolean;

    const control: AbstractControl = this.f[field];

    if (control) {
      valid = control.status.toLowerCase() === "valid";

      if (!valid) {
        retVal = "is-invalid required";
      }
    }

    return retVal;
  }

  isDuplicateCompanies(estabs): boolean {
    let estabDuplicate: boolean;
    let importerDuplicate: boolean;
    let retVal = false;

    const valueArr = estabs.map(function (estab) {
      return estab.establishmentCompany.companyRevisionId;
    });

    estabDuplicate = valueArr.some(function (estab, idx) {
      return valueArr.indexOf(estab) !== idx;
    });

    if (!estabDuplicate) {
      retVal = false;

      estabs.forEach((estab) => {
        const impArr = estab.importers.map(function (importer) {
          return importer.importerCompanyRevisionId;
        });

        importerDuplicate = impArr.some(function (importer, idx) {
          return impArr.indexOf(importer) !== idx;
        });

        if (importerDuplicate) {
          retVal = true;
        }
      });
    } else {
      retVal = true;
    }

    return retVal;
  }

  prepareDataForSave(data) {
    this.erData = new IER();
    const registrantCompany = data && data.registrantCompany ? data.registrantCompany : new ILLCompany();
    const registrantContact = data && data.registrantContact ? data.registrantContact : new ISSDPConctact();

    this.erData.erId = data && data.erId ? data.erId : 0;
    this.erData.erRevisionId = data && data.erRevisionId ? data.erRevisionId : 0;
    this.erData.majorRevision = data && data.majorRevision ? data.majorRevision : 0;
    this.erData.splTitle = data && data.splTitle ? data.splTitle : "";
    this.erData.splVersion = this.splVersion ? this.splVersion : "1";
    this.erData.splServiceType = this.getGenericKeyObject(
      this.splSubmissionTypeDdwDS,
      data && data.splServiceTypeId,
      "label",
      "id"
    );
    this.erData.setId = this.setId;
    this.erData.dunsNumber = data && data.dunsNumber ? data.dunsNumber : "";
    this.erData.versionNumber = data && data.versionNumber ? data.versionNumber : "";
    if (data && data.effectiveTime !== "") {
      this.erData.effectiveTime =
        data.effectiveTime instanceof Date
          ? data.effectiveTime.toDateString()
          : data.effectiveTime;
    }
    this.erData.busCategory = this.getGenericKeyObjectForBC(
      this.formData[3],
      this.businessCategoryId
    );

    this.erData.registrantCompany = new ILLCompany();
    this.erData.registrantCompany.companyRevisionId =
      this.toPositiveNumber(registrantCompany.companyRevisionId);
    this.erData.registrantCompany.companyName =
      registrantCompany.companyName || "";

    this.erData.registrantContact = new ISSDPConctact();
    this.erData.registrantContact.contactRevisionId =
      registrantContact.contactRevisionId ? registrantContact.contactRevisionId : 0;

    if (this.asArray(data && data.establishments).length > 0) {
      this.erData.establishments = [];

      this.asArray(data.establishments).forEach((estab) => {
        const establishment = new IEstablishment();
        const establishmentCompany = estab && estab.establishmentCompany ? estab.establishmentCompany : new ILLCompany();
        const establishmentContact = estab && estab.establishmentContact ? estab.establishmentContact : new ISSDPConctact();

        establishment.establishmentId = estab.establishmentId
          ? estab.establishmentId
          : 0;
        establishment.establishmentName = establishmentCompany.companyName
          ? establishmentCompany.companyName
          : "";
        establishment.sequence = estab.sequence ? estab.sequence : 0;

        const estabCompany = new ILLCompany();
        estabCompany.companyRevisionId =
          this.toPositiveNumber(establishmentCompany.companyRevisionId);
        establishment.establishmentCompany = estabCompany;

        const estabContact = new ISSDPConctact();
        estabContact.contactRevisionId =
          establishmentContact.contactRevisionId ? establishmentContact.contactRevisionId : 0;
        establishment.establishmentContact = estabContact;

        const usAgentCompany = new ILLCompany();
        const usAgentContact = new ISSDPConctact();

        if (
          estab.usAgentCompany &&
          Object.keys(estab.usAgentCompany).length > 0 &&
          estab.usAgentCompany.companyRevisionId
        ) {
          usAgentCompany.companyRevisionId =
            estab.usAgentCompany.companyRevisionId;
          usAgentContact.contactRevisionId =
            estab.usAgentContact ? estab.usAgentContact.contactRevisionId : 0;

          establishment.usAgentCompany = usAgentCompany;
          establishment.usAgentContact = usAgentContact;
        }

        if (this.asArray(estab && estab.importers).length > 0) {
          establishment.importers = [];

          this.asArray(estab.importers).forEach((imp) => {
            if (imp.importerCompany && imp.importerCompany.companyRevisionId) {
              const importer = new IImporter();
              importer.importerId = imp.importerId ? imp.importerId : 0;
              importer.sequence = imp.sequence ? imp.sequence : 0;

              importer.importerCompany = new ILLCompany();
              importer.importerCompany.companyRevisionId =
                imp.importerCompany.companyRevisionId;
              importer.importerContact = new ISSDPConctact();
              importer.importerContact.contactRevisionId =
                imp.importerContact ? imp.importerContact.contactRevisionId : 0;

              establishment.importers.push(importer);
            }
          });
        }

        this.erData.establishments.push(establishment);
      });
    }
  }
  // Build an ILLBusinessCategory object for Business Category
  getGenericKeyObjectForBC(list: any[], id: any): ILLBusinessCategory {
    const retVal = new ILLBusinessCategory();
    const idText = id ? id.toString() : "";

    if (this.asArray(list).length > 0 && idText) {
      const businessCategory = this.asArray(list).find(
        (x) => x && x["categoryId"] === idText
      );

      if (businessCategory) {
        retVal.categoryId = idText !== "0" ? id : "";
        retVal.label = businessCategory["label"] || "";
      }
    }
    return retVal;
  }

  get f() {
    return this.erForm.controls;
  }

  // Validation error handling
  initValidation() {
    // Now, read the validation errors from local storage (if present)
    if (this.storageManagerService.read("showValidationMessages")) {
      this.splValidationMessages = this.storageManagerService.read(
        "splValidationMessages"
      );
    }
    this.storageManagerService.write("showValidationMessages", false);
    this.storageManagerService.write("splValidationMessages", {});
    this.erForm.markAsPristine();
  }

  ddwSelectionChanged(event, name, index?: number, innerIndex?: number) {
    const value = event && event.value;
    const normalizedName = name ? name.toLowerCase() : "";

    if (name !== "splSubmissionTypeId" && value) {
      let company = new ILLCompany();
      const companyTypes = this.formData && this.formData[2] ? this.formData[2].data : {};

      // establishment has different structure than other companies
      if (name === "establishments" || name === "establishmentsThirdParty") {
        const establishment = this.asArray(companyTypes && companyTypes[name]).find(
          (x) =>
            this.toPositiveNumber(x && x.establishmentCompany && x.establishmentCompany.companyRevisionId) ===
            this.toPositiveNumber(value)
        );
        company = establishment && establishment.establishmentCompany ? establishment.establishmentCompany : new ILLCompany();
      } else {
        company = this.findByNumericId(
          companyTypes && companyTypes[name],
          value,
          "companyRevisionId"
        ) || new ILLCompany();
      }

      if (this.toPositiveNumber(company.companyRevisionId)) {
        const contact = this.getFirstContact(company);
        const contactRevisionId = this.toPositiveNumber(contact.contactRevisionId);

        this.formErrors.missingCompanyRevisionId = "";
        this.submitted = false;

        this.formDetailData.establishments = this.asArray(this.formDetailData.establishments);
        if (index >= 0 && !this.formDetailData.establishments[index]) {
          this.formDetailData.establishments[index] = new IEstablishment();
        }

        switch (normalizedName) {
          case "registrants":
            this.registrantCompanyRevisionId = value;
            this.registrantCompany = company;
            this.registrantContactRevisionId = contactRevisionId;
            this.registrantContact = contact;

            this.erForm.patchValue({
              registrantCompany: this.registrantCompany,
              registrantCompanyRevisionId: this.registrantCompanyRevisionId,
              registrantContactRevisionId: this.registrantContactRevisionId,
              formName: this.registrantCompany.companyName || "",
              registrantContact: contact,
            });

            break;
          case "establishments":
            this.formDetailData.establishments[index].establishmentCompany = company;
            this.formDetailData.establishments[index].establishmentContact = contact;

            if (this.isForeignCountry(company.country)) {
              if (
                !this.formDetailData.establishments[index].importers ||
                this.formDetailData.establishments[index].importers.length ===
                  0
              ) {
                this.formDetailData.establishments[index].importers = [];
                this.formDetailData.establishments[index].importers.push(
                  new IImporter()
                );
              }
            } else {
              this.formDetailData.establishments[index].usAgentCompany =
                new ILLCompany();
              this.formDetailData.establishments[index].usAgentContact =
                new ISSDPConctact();
              this.formDetailData.establishments[index].importers = [];
            }

            this.setEstabControl();

            break;

          case "usagents":
            this.formDetailData.establishments[index].usAgentCompany = company;
            this.formDetailData.establishments[index].usAgentContact = contact;

            this.setEstabControl();

            break;

          case "importers":
            this.formDetailData.establishments[index].importers =
              this.asArray(this.formDetailData.establishments[index].importers);

            if (
              this.formDetailData.establishments[index].importers.length > 0 &&
              innerIndex >= 0
            ) {
              this.formDetailData.establishments[index].importers[
                innerIndex
              ].importerCompany = company;
              this.formDetailData.establishments[index].importers[
                innerIndex
              ].importerContact = contact;
            } else {
              const importer = new IImporter();

              importer.importerCompany = company;
              importer.importerContact = contact;

              this.formDetailData.establishments[index].importers.push(
                importer
              );
            }

            this.setEstabControl();
            break;
        }
      }
    } else {
      if (name === "splSubmissionTypeId") {
        this.splServiceTypeId = value;

        this.erForm.patchValue({
          splServiceTypeId: value,
        });
      }

      if (!value) {
        this.ddwOnClear(name, index, innerIndex);
      } else {
        if (
          (value === this.erService.ER_SPL_NO_CHANGE_NOTIFICATION ||
            value ===
              this.erService.ER_SPL_OUT_OF_BUSINESS_NOTIFICATION) &&
          this.erRevisionId
        ) {
          this.restrictedSplSubmissionType = true;

          this.splSubmissionTypeName = event && event.itemData ? event.itemData.labelAndCode : "";

          this.ddwSubmissionTypePreviousData = event ? event.previousItemData : null;

          this.confirmDialog.show();
        } else {
          this.restrictedSplSubmissionType = false;
        }
      }
    }

    this.erForm.markAsDirty();
  }

  getState(countryRegion: any): any {
    let code;

    if (countryRegion && countryRegion.indexOf("(") > 0) {
      code = countryRegion.split("(")[1].split(")")[0];
    }

    return code ? code : countryRegion;
  }

  getCountryCode(countryOrId: any): string {
    const country = this.resolveCountry(countryOrId);
    return country && country.code ? country.code : "";
  }

  getGenericKeyObject(
    list: any[],
    id: any,
    TextFieldName: string,
    idFieldName: string
  ): ILLGenericKeys {
    const retVal = new ILLGenericKeys();
    const lookupList = this.asArray(list);
    const numericId = this.toPositiveNumber(id);

    if (!lookupList.length || !numericId) {
      return retVal;
    }

    const lookupItem = lookupList.find(
      (x) => this.toPositiveNumber(x && x[idFieldName]) === numericId
    );

    if (lookupItem) {
      retVal.id = id;
      retVal.code = this.getCode(lookupItem["labelAndCode"]);
      retVal.label = lookupItem[TextFieldName] || "";
    }

    return retVal;
  }

  // get code from description
  getCode(desc: string): string {
    let code = "";

    if (desc) {
      const pos = desc.indexOf("(");
      if (pos || pos === 0) {
        code = desc.substring(pos + 1, desc.length - 1);
      }
    }
    return code;
  }

  // Dynamically generate new GUID
  generateGUID() {
    this.setId = UUID.UUID();

    this.erForm.markAsDirty();
  }

  // Get data from the resolver and populate the controls
  populateDataFromResolver() {
    if (this.formData && this.formData.error) {
      this.toastr.error(this.formData.error);
    } else {
      if (this.formData) {
        if (this.formData[0] && this.formData[0].data) {
          this.formDetailData = this.formData[0].data;
          this.formDetailData.registrantCompany =
            this.formDetailData.registrantCompany || new ILLCompany();
          this.formDetailData.registrantContact =
            this.formDetailData.registrantContact || new ISSDPConctact();
          this.formDetailData.splServiceType =
            this.formDetailData.splServiceType || new ILLGenericKeys();
          this.formDetailData.establishments =
            this.asArray(this.formDetailData.establishments);

          if (
            this.formDetailData.splServiceType &&
            (this.toPositiveNumber(this.formDetailData.splServiceType.id) ===
              this.erService.ER_SPL_NO_CHANGE_NOTIFICATION ||
              this.toPositiveNumber(this.formDetailData.splServiceType.id) ===
                this.erService.ER_SPL_OUT_OF_BUSINESS_NOTIFICATION) &&
            this.erRevisionId
          ) {
            this.restrictedSplSubmissionType = true;
          }

          if (this.formDetailData.registrantCompany) {
            this.registrantCompany = this.formDetailData.registrantCompany;
            this.registrantCompanyRevisionId =
              this.formDetailData.registrantCompany.companyRevisionId;
          }
          if (this.formDetailData.registrantContact) {
            this.registrantContact = this.formDetailData.registrantContact;
            this.registrantContactRevisionId =
              this.formDetailData.registrantContact.contactRevisionId;
          }

          if (this.formDetailData.establishments) {
            this.establishments = this.formDetailData.establishments;
          }

          // this.businessCategoryId = this.formDetailData.busCategory ? (this.formDetailData.busCategory.categoryId ? this.formDetailData.busCategory.categoryId : null) : null;
        } else {
          this.formDetailData = new IER();
          this.formDetailData.registrantCompany = new ILLCompany();
          this.formDetailData.registrantContact = new ISSDPConctact();
          // this.formDetailData.busCategory = new ILLBusinessCategory();
          this.formDetailData.splServiceType = new ILLGenericKeys();
          this.formDetailData.establishments = [];
          this.formDetailData.establishments.push(new IEstablishment());
        }

        // Submission types
        if (this.formData && this.formData[1]) {
          this.allLOV = this.asArray(this.formData[1].data);
          this.splSubmissionTypeDdwDS = this.getLOVDataByType("doc_type_er");
        }

        // Revision History
        if (this.formData[4] && this.formData[4].data) {
          this.erRevisions = this.asArray(this.formData[4].data);
          if (this.erRevisions.length > 0) {
            this.revisionCurrentRevision = this.erRevisions[0];
            this.current =
              this.erRevisions[0]["erRevisionId"] === +this.erRevisionId;
            const revision = this.erRevisions.find(
              (r) => r.erRevisionId === +this.erRevisionId
            );
            if (revision) {
              this.versionToDisplay = this.erRevisions.find(
                (r) => r.erRevisionId === +this.erRevisionId
              ).formVersion;
            }
          }
        }

        // Business Categories
        if (this.formData[3]) {
          this.businessCategoryModel = {
            placeholder: "Select Business Category",
            dataSource: this.formData[3],
            fields: { value: "categoryId", text: "label" },
            width: "200px",
          };
        }

        // Country list
        if (this.formData[5]) {
          this.countries = this.asArray(this.formData[5].countryList);
          this.regions = this.asArray(this.formData[5].regionList);

          const usCountry = this.resolveCountry({ code: "USA" });
          const umiCountry = this.resolveCountry({ code: "UMI" });
          this.usBasedCode = usCountry ? usCountry.id : 0;
          this.usUMICode = umiCountry ? umiCountry.id : 0;
        }

        // Contacts list
        if (this.formData[6]) {
          this.contacts = this.asArray(this.formData[6]["latestAvailableContactsList"]);
          this.refreshStaleFormContacts();
        }

        // populate the Registrant Company dropdown
        if (this.formData && this.formData[2]) {
          this.setCompaniesDdw();
        }
      }

      this.populateHeaders();

      this.setERForm(this.formDetailData ? this.formDetailData : "");
    }
  }

  ddwOnClear(name, outerIndex?: number, innerIndex?: number) {
    switch (name.toLowerCase()) {
      case "registrants":
        this.registrantCompanyRevisionId = 0;
        this.erForm.patchValue({
          registrantCompanyRevisionId: "",
          registrantCompany: "",
        });
        break;
      case "establishments":
        this.formDetailData.establishments[outerIndex].establishmentCompany =
          new ILLCompany();

        this.formDetailData.establishments[outerIndex].establishmentContact =
          new ISSDPConctact();

        this.formDetailData.establishments[outerIndex].usAgentCompany =
          new ILLCompany();

        this.formDetailData.establishments[outerIndex].importers = [];

        this.setEstabControl();
        break;

      case "usagents":
        this.formDetailData.establishments[outerIndex].usAgentCompany =
          new ILLCompany();

        this.formDetailData.establishments[outerIndex].usAgentContact =
          new ISSDPConctact();

        this.setEstabControl();
        break;

      case "importers":
        this.formDetailData.establishments[outerIndex].importers[
          innerIndex
        ].importerCompany = new ILLCompany();

        this.formDetailData.establishments[outerIndex].importers[
          innerIndex
        ].importerContact = new ISSDPConctact();

        this.setEstabControl();
        break;
    }
  }

  editorChanged(event) {
    const column = event.data.name;
    const value = event.data.value;

    switch (column) {
      case "setId":
        this.setId = value;

        this.erForm.patchValue({
          setId: value,
        });
        break;
      case "ipeBusinessCategory":
        if (value) {
          //   const busCat = this.formData[3].find(b => b.categoryId === value);

          //   const modifiedBusOp: ILLBusinessCategory = new ILLBusinessCategory();
          //   modifiedBusOp.categoryId = busCat.categoryId;
          //   modifiedBusOp.label = busCat.label;

          //   this.erForm.patchValue({
          //     businessCategoryId: +value,
          //     busCategory: modifiedBusOp
          //   });

          this.businessCategoryId = +value;
        }

        break;
    }
    this.erForm.markAsDirty();
  }

  setCompaniesDdw() {
    const companyTypes: ILLCustomerCompaniesByTypeWrapper =
      this.formData && this.formData[2] ? this.formData[2].data : null;

    this.registrantCompanies = this.asArray(companyTypes && companyTypes.registrants);
    this.estabCompanies = this.asArray(companyTypes && companyTypes.establishments);
    this.estabUsAgentCompanies = this.asArray(companyTypes && companyTypes.usAgents);
    this.estabImporterCompanies = this.asArray(companyTypes && companyTypes.importers);
    this.registrantCompaniesDdwDS = [];
    this.estabCompaniesDdwDS = [];
    this.estabUsAgentCompaniesDdwDS = [];
    this.estabImporterCompaniesDdwDS = [];

    if (this.registrantCompanies.length > 0) {
      this.registrantCompanies.forEach((company: ILLCompany) => {
        if (!this.toPositiveNumber(company && company.companyRevisionId)) {
          return;
        }
        const ds = { id: 0, name: "" };
        ds.id = +company.companyRevisionId;
        ds.name = company.companyName || "";
        this.registrantCompaniesDdwDS.push(ds);
      });

      //this.registrantCompaniesDdwDS.sort(this.compare);
    }

    if (this.estabCompanies.length > 0) {
      this.estabCompanies.forEach((company: ILLEstablishment) => {
        if (
          !company ||
          !company.establishmentCompany ||
          !this.toPositiveNumber(company.establishmentCompany.companyRevisionId)
        ) {
          return;
        }
        const ds = { id: 0, name: "", cId: "" };
        ds.id = +company.establishmentCompany.companyRevisionId;
        ds.name = company.establishmentCompany.companyName || "";
        this.estabCompaniesDdwDS.push(ds);
      });

      //this.estabCompaniesDdwDS.sort(this.compare);
    }

    if (this.estabUsAgentCompanies.length > 0) {
      this.estabUsAgentCompanies.forEach((company: ILLCompany) => {
        if (!this.toPositiveNumber(company && company.companyRevisionId)) {
          return;
        }
        const ds = { id: 0, name: "" };
        ds.id = +company.companyRevisionId;
        ds.name = company.companyName || "";
        this.estabUsAgentCompaniesDdwDS.push(ds);
      });

      //this.estabUsAgentCompaniesDdwDS.sort(this.compare);
    }

    if (this.estabImporterCompanies.length > 0) {
      this.estabImporterCompanies.forEach((company: ILLCompany) => {
        if (!this.toPositiveNumber(company && company.companyRevisionId)) {
          return;
        }
        const ds = { id: 0, name: "" };
        ds.id = +company.companyRevisionId;
        ds.name = company.companyName || "";
        this.estabImporterCompaniesDdwDS.push(ds);
      });

      //this.estabImporterCompaniesDdwDS.sort(this.compare);
    }
  }

  // Get a list of LOVs by doc_type, created a new column that will
  // concatenate label and code fields for displaying purpose
  getLOVDataByType(type: string): any[] {
    const dataLOV = this.asArray(this.allLOV).filter(
      (x) => x && x.lsP_FORM_TYPE === type
    );
    const newLOV = dataLOV.map((item) => {
      const container = {};
      container["id"] = item["id"];
      container["label"] = item["label"] || "";
      container["labelAndCode"] = (item["label"] || "") + " (" + (item["code"] || "") + ")";
      return container;
    });

    return newLOV;
  }

  // populate Header Section
  populateHeaders() {
    if (this.formDetailData) {
      if (this.erRevisionId) {
        this.setId = this.formDetailData.setId;
        // versionToDisplay is now formatted as "X.Y (Draft)" by SP_Get_ERFormRevision_History.
        // Prefer the form data's isDraftMode flag when available; fall back to checking the version string.
        const versionText = this.versionToDisplay ? this.versionToDisplay.toString() : "";
        const splServiceType = this.formDetailData.splServiceType || new ILLGenericKeys();
        this.isDraftMode = this.formDetailData?.isDraftMode === true || versionText.toLowerCase().includes("draft");
        this.status =
          this.isDraftMode ? "Draft" : "Active";
        this.splVersion = this.formDetailData.splVersion;
        this.lastModifiedBy = this.formDetailData.modifiedByUser;
        this.lastModifiedDate = this.formDetailData.modifiedByDate
          ? this.datepipe.transform(
              this.formDetailData.modifiedByDate,
              "MMM d, y"
            )
          : "";
        this.splSubmissionTypeMissing =
          this.toPositiveNumber(splServiceType.id) === 0 ? false : true;
        this.splServiceTypeId = this.toPositiveNumber(splServiceType.id);
        this.revisionDateMissing = this.erForm.controls.effectiveTime.value
          ? false
          : true;
        this.businessCategoryId = this.formDetailData.busCategory
          ? this.formDetailData.busCategory.categoryId
            ? +this.formDetailData.busCategory.categoryId
            : null
          : null;
      }
      this.setIdModel = {
        placeholder: "Enter setId",
      };
    }
  }

  buildDlgBtnYes: EmitType<object> = () => {
    // versionToDisplay is now formatted as "X.Y (Draft)" by SP_Get_ERFormRevision_History for drafts.
    if (
      +this.updatedVersion > 0 ||
      (this.versionToDisplay?.toLowerCase().includes("draft") && this.updatedVersion === "1")
    ) {
      this.formDetailData.splVersion = "" + this.updatedVersion;

      this.erForm.patchValue({
        splVersion: "" + this.updatedVersion,
      });
      this.buildModalDialog.hide();
      return this.confirmDialogSelection$.next(true);
    } else {
      this.invalidSplVersion = true;
    }
  };

  buildDlgBtnNo: EmitType<object> = () => {
    this.invalidSplVersion = false;

    const splInput = document.getElementById("splVersionModalInput");
    if (splInput) {
      (splInput as any).value = "";
    }
    this.buildModalDialog.hide();
    return this.confirmDialogSelection$.next(false);
  };

  // eslint-disable-next-line @typescript-eslint/member-ordering
  buildDlgButtons: Object[] = [
    {
      click: this.buildDlgBtnNo.bind(this),
      buttonModel: { content: "Cancel" },
    },
    {
      click: this.buildDlgBtnYes.bind(this),
      buttonModel: { content: "Continue", isPrimary: true },
    },
  ];

  onBuildModalOverlayClick: EmitType<object> = () => {
    this.buildModalDialog.hide();
  };

  // Increase SPL version by 1
  splVersionModalOpen() {
    const splInput = document.getElementById("splVersionModalInput");
    if (splInput) {
      if (this.erRevisions && this.erRevisions.length > 0) {
        // Brand-new ER: only one revision exists, and it is a draft (no published version yet).
        // Draft formVersion is now formatted as "X.Y (Draft)" by SP_Get_ERFormRevision_History.
        if (
          this.erRevisions.length === 1 &&
          this.erRevisions[0].formVersion?.toLowerCase().includes("draft")
        ) {
          (splInput as any).value = "1";
        } else {
          (splInput as any).value = `${+this.formDetailData.splVersion + 1}`;
        }
      } else {
        (splInput as any).value = "1";
      }
      this.updatedVersion = (splInput as any).value;
    }
  }

  validateSplVersionInput(event) {
    this.invalidSplVersion = false;

    if (event.target.value) {
      this.updatedVersion = parseInt(event.target.value, 10).toString();
    } else {
      this.updatedVersion = "";
    }
  }

  // Validate SPL version: has to be a whole number
  formatSplVersion(version) {
    return !isNaN(version)
      ? (parseFloat(version) + 1).toFixed(1)
      : (0).toFixed(1);
  }

  public expanding(e: ExpandEventArgs) {
    if (this.clickEventArgs) {
      const header = closest(
        this.clickEventArgs.target as Element,
        ".e-acrdn-header"
      );
      const checkboxEle = closest(
        this.clickEventArgs.target as HTMLInputElement,
        "label"
      );
      if (header && checkboxEle) {
        e.cancel = true;
      }
    }
  }

  // Create an overlay effect for verision history modal popup
  onOverlayClick() {
    this.revHistoryDialog.hide();
    this.revHistoryVisible = false;
  }

  onBusOpsOverlayClick() {
    this.busOpsDialog.hide();
    this.busOpsDialogVisible = false;
  }

  onSPLTypeOverlayClick: EmitType<object> = () => {
    this.confirmDialog.hide();
  };

  // custom validation method to make sure SPL version number is a whole number that is greater than zero
  customValidateFn(args) {
    let ret = false;
    if (args.value) {
      const matches = args.value.match(/^[1-9]+[0-9]*$/);
      ret = matches ? true : false;
    }
    return ret;
  }

  buildERModal() {
    this.submitted = true;

    this.f.effectiveTime.setValidators([Validators.required]);
    this.f.effectiveTime.updateValueAndValidity();

    if (this.formErrors.missingCompanyRevisionId) {
      this.erForm.setErrors({ invalid: true });
    }

    if (this.erForm.invalid) {
      this.setFormErrors(true);

      this.pageLoading = false;
      this.saveLoading = false;
      this.buildLoading = false;
    } else {
      // show modal for setting a version and cancel the build if Cancel is seleced.
      this.buildModalDialog.show();

      this.sub = this.confirmDialogSelection$.subscribe((choice) => {
        if (!choice) {
          this.buildLoading = false;
          this.pageLoading = false;
        } else {
          this.erForm.markAsDirty();
          this.buildLoading = true;
          this.pageLoading = true;
          this.cdRef.detectChanges();

          if (!this.buildERComplete) {
            this.buildERspl();
            this.buildERComplete = true;
          }
        }
      });
    }
  }

  buildERspl() {
    const modifiedByUser = this.storageManagerService.read("userData").name;

    const duplicateCompanies = this.isDuplicateCompanies(
      this.erForm.value.establishments
    );

    if (!duplicateCompanies) {
      this.prepareDataForSave(this.erForm.value);

      // Call endpoint to build SPL
      this.sub = this.erService
        .buildERspl(
          this.erData,
          modifiedByUser,
          this.ignoreWarnings,
          +this.updatedVersion
        )
        .subscribe(
          (response) => {
            if (response?.isSuccess) {
              this.toastr.success(`${response.message}`);
              this.buildLoading = false;
              this.saveLoading = false;
              this.pageLoading = false;
              this.storageManagerService.write("showValidationMessages", true);
              this.cdRef.detectChanges();
              // store this in localStorage so that we can display them on page load
              this.storageManagerService.write(
                "splValidationMessages",
                response?.data?.validationMessages
              );
              this.isSaving = true;

              if (response?.data?.validationMessages) {
                this.router.navigate([
                  `/er-form/${response.data?.erRevisionId}`,
                ]);
              } else {
                this.toastr.success(
                  "Your SPL XML file is being generated.  When the process is complete, the file will be available on the Deliveries tab."
                );
                this.router.navigate([`/er-form-dashboard`]);
              }
            } else {
              this.toastr.error(`${response?.message}`);
              this.pageLoading = false;
              this.saveLoading = false;
              this.buildLoading = false;
              this.cdRef.detectChanges();
            }
          },
          (error) => {
            this.saveLoading = false;
            this.buildLoading = false;
            this.pageLoading = false;
            this.toastr.error(
              error && error.errorMessage ? error.errorMessage : error
            );
            this.cdRef.detectChanges();
          }
        );
    } else {
      this.pageLoading = false;
      this.saveLoading = false;
      this.buildLoading = false;
      this.toastr.error("Duplicate companies are not allowed");
    }
  }

  validateERform() {
    this.submitted = true;

    // First we need to save the current ER as a draft (if Form is dirty) so that all data is saved.
    const modifiedByUser = this.storageManagerService.read("userData").name;

    let hasChanges = false;
    const ignoreWarningsValidate = false;
    const erRevisionId = this.activatedRoute.snapshot.params.revisionId;

    const duplicateCompanies = this.isDuplicateCompanies(
      this.erForm.value.establishments
    );

    if (!duplicateCompanies) {
      this.prepareDataForSave(this.erForm.value);

      this.validateLoading = true;
      this.pageLoading = true;
      if (this.erForm.touched || this.erForm.dirty) {
        hasChanges = true;
      }

      if (this.formErrors.missingCompanyRevisionId) {
        this.erForm.setErrors({ invalid: true });
      }

      // stop here if form is invalid
      if (this.erForm.invalid) {
        this.setFormErrors();

        this.pageLoading = false;
        this.validateLoading = false;
      } else {
        this.sub = this.erService
          .validateERform(
            this.erData,
            erRevisionId,
            modifiedByUser,
            hasChanges,
            ignoreWarningsValidate
          )
          .subscribe(
            (response) => {
              if (response?.isSuccess) {
                this.pageLoading = false;
                this.validateLoading = false;

                if (hasChanges) {
                  this.toastr.success(
                    `Successfully Saved Draft Form: ${response?.data?.erRevisionId}`
                  );
                  // The form has changed so reload the page and show the Validation Messages
                  this.storageManagerService.write(
                    "showValidationMessages",
                    true
                  );

                  // store this in localStorage so that we can display them on page load
                  this.storageManagerService.write(
                    "splValidationMessages",
                    response?.data?.validationMessages
                  );

                  this.isSaving = true;

                  this.router.navigate([
                    `/er-form/${response?.data?.erRevisionId}`,
                  ]);
                } else {
                  this.toastr.success(
                    `Successfully Validated Form: ${erRevisionId}`
                  );
                  this.splValidationMessages = response?.data;
                  this.showValidationMessages =
                    Object.keys(this.splValidationMessages.validationMessages)
                      .length > 0;

                  if (this.showValidationMessages) {
                    if (this.errorMessagesComponent) {
                      this.pageLoading = false;
                      this.validateLoading = false;
                      this.errorMessagesComponent.showMessages(
                        this.splValidationMessages
                      );
                    }
                  }
                  this.cdRef.detectChanges();
                }
              } else {
                this.toastr.error(`${response?.message}`);
                this.pageLoading = false;
                this.validateLoading = false;
                this.cdRef.detectChanges();
              }
            },
            (error) => {
              this.toastr.error(
                error && error.errorMessage ? error.errorMessage : error
              );
              this.pageLoading = false;
              this.validateLoading = false;
              this.cdRef.detectChanges();
            }
          );
      }
    } else {
      this.pageLoading = false;
      this.saveLoading = false;
      this.buildLoading = false;
      this.toastr.error("Duplicate companies are not allowed");
    }
  }

  // SPL Revision Date datapicker is being clicked
  onOpen(e: any) {
    this.erForm.markAsDirty();
  }

  revisionDateChanged(event) {
    this.erForm.markAsDirty();
  }

  canDeactivate() {
    if (this.erForm.touched && !this.isSaving) {
      return confirm(
        `Are you sure you want to navigate away and discard your changes?`
      );
    }

    return true;
  }

  // Display version history
  displayRevisionHistory(event) {
    const classList = Array.from(event.target.classList);

    if (classList.indexOf("version") >= 0) {
      this.revHistoryVisible = true;
      this.revHistoryDialog.show();
    }
  }

  // close version history modal popup
  revisionHistoryClose(event) {
    this.revHistoryDialog.hide();
    this.revHistoryVisible = false;
  }

  // display revision
  goToRevision(revisionId: number) {
    if (this.revHistoryDialog) {
      this.revHistoryDialog.hide();
      this.revHistoryVisible = false;
    }

    if (revisionId) {
      this.router.navigate([`/er-form/${revisionId}`]);
    }
  }

  /**
   * The function drills to down from the FormGroup or FormArray down
   * to the AbstractControl in order to check if the value is entered.
   * Populates the FormErrors object based on the Validators attached to the formControls.
   * @param {FormGroup} group passed by the form validation.
   */
  logValidationErrors(group: UntypedFormGroup = this.erForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);

      this.formErrors[key] = "";
      if (
        abstractControl &&
        !abstractControl.valid &&
        (abstractControl.touched || abstractControl.dirty)
      ) {
        const messages = this.validationMessages[key];

        for (const errorKey in abstractControl.errors) {
          if (errorKey) {
            this.formErrors[key] += messages ? messages[errorKey] + " " : "";
          }
        }
      }

      if (abstractControl instanceof UntypedFormGroup) {
        this.logValidationErrors(abstractControl);
      }

      // We need this additional check to get to the FormGroup
      // in the FormArray and then recursively call this
      // logValidationErrors() method to fix the broken validation
      if (abstractControl instanceof UntypedFormArray) {
        for (const control of abstractControl.controls) {
          if (control instanceof UntypedFormGroup) {
            this.logValidationErrors(control);
          }
        }
      }
    });
  }

  showBusOps(company) {
    const establishmentCompany =
      company && company.value ? company.value.establishmentCompany : null;
    this.companyName = establishmentCompany && establishmentCompany.companyName
      ? establishmentCompany.companyName
      : "";
    this.businessOperations =
      this.asArray(establishmentCompany && establishmentCompany.businessOperations);
    this.busOpsDialog.show();
  }

  onBusOpsCloseClicked() {
    this.busOpsDialog.hide();
    this.busOpsDialogVisible = false;
  }

  addEstab() {
    this.submitted = false;

    this.formDetailData.establishments.push(new IEstablishment());

    this.setEstabControl();

    this.erForm.markAllAsTouched();
    this.erForm.markAsDirty();
  }

  removeEstab(i) {
    this.submitted = false;
    this.formDetailData.establishments.splice(i, 1);

    // Clear the error flag if all establishment company dropdown controls are being populated
    let bMissingEstCompany = false;
    this.formDetailData.establishments.forEach((estab: IEstablishment) => {
      if (!estab.establishmentCompany) {
        bMissingEstCompany = true;
      }
    });
    if (!bMissingEstCompany) {
      this.formErrors.missingCompanyRevisionId = "";
    }

    this.setEstabControl();

    this.erForm.markAsDirty();
    this.erForm.markAsTouched();
  }

  addImporter(i) {
    this.submitted = false;

    this.formDetailData.establishments[i].importers.push(new IImporter());

    this.setEstabControl();

    this.erForm.markAllAsTouched();
    this.erForm.markAsDirty();
  }

  removeImporter(estabIndex, importerIndex) {
    if (this.formDetailData.establishments[estabIndex].importers.length === 1) {
      this.formDetailData.establishments[estabIndex].importers[0] = new IImporter();
    } else {
      this.formDetailData.establishments[estabIndex].importers.splice(
        importerIndex,
        1
      );
    }
    this.submitted = false;

    this.setEstabControl();

    this.erForm.markAsDirty();
    this.erForm.markAsTouched();
  }

  // Check if the previously saved company is the latest version
  isCompanyLatest(
    companyType,
    companyRevisionId,
    estabIndex?: number,
    importerIndex?: number
  ) {
    let company;
    const companyRevisionIdNumber = this.toPositiveNumber(companyRevisionId);

    // when company data changed and company not found it passes 0, for the new company it sends null.
    if (companyRevisionIdNumber) {
      const companyTypes = this.formData && this.formData[2] ? this.formData[2].data : {};

      if (
        companyType === "establishments" ||
        companyType === "establishmentsThirdParty"
      ) {
        company = this.asArray(companyTypes && companyTypes[companyType]).find(
          (x) =>
            this.toPositiveNumber(x && x.establishmentCompany && x.establishmentCompany.companyRevisionId) ===
            companyRevisionIdNumber
        );
      } else {
        company = this.asArray(companyTypes && companyTypes[companyType]).find(
          (x) => this.toPositiveNumber(x && x.companyRevisionId) === companyRevisionIdNumber
        );
      }

      if (company) {
        return false;
      }
    } else {
      switch (companyType) {
        case "establishments":
        case "establishmentsThirdParty":
          if (
            this.formDetailData &&
            this.formDetailData.establishments &&
            this.formDetailData.establishments[estabIndex] &&
            !this.formDetailData.establishments[estabIndex].establishmentCompany
          ) {
            return false;
          }

          break;
        case "registrants":
          if (this.formDetailData && this.formDetailData.registrantCompany) {
            if (!this.formDetailData.registrantCompany.companyRevisionId) {
              return false;
            }
          }
          break;
        case "usAgents":
          if (
            this.formDetailData &&
            this.formDetailData.establishments &&
            this.formDetailData.establishments[estabIndex] &&
            this.formDetailData.establishments[estabIndex].usAgentCompany
          ) {
            if (
              !this.formDetailData.establishments[estabIndex].usAgentCompany
                .companyRevisionId
            ) {
              return false;
            }
          }

          break;

        case "importers":
          if (
            this.formDetailData &&
            this.formDetailData.establishments &&
            this.formDetailData.establishments[estabIndex] &&
            this.formDetailData.establishments[estabIndex].importers &&
            this.formDetailData.establishments[estabIndex].importers.length >
              0 &&
            this.formDetailData.establishments[estabIndex].importers[
              importerIndex
            ] &&
            this.formDetailData.establishments[estabIndex].importers[
              importerIndex
            ].importerCompany
          ) {
            if (
              this.formDetailData &&
              this.formDetailData.establishments &&
              this.formDetailData.establishments[estabIndex].importers[
                importerIndex
              ] &&
              !this.formDetailData.establishments[estabIndex].importers[
                importerIndex
              ].importerCompany.companyRevisionId
            ) {
              return false;
            }
          }
          break;
      }

      return false;
    }

    return true;
  }

  // Check if the previously saved contact for the company is the latest version
  isContactLatest(contactRevisionId) {
    return !this.isContactRevisionLatest(contactRevisionId);
  }

  isContactRevisionLatest(contactRevisionId): boolean {
    const contactRevisionIdNumber = this.toPositiveNumber(contactRevisionId);
    if (!contactRevisionIdNumber) {
      return false;
    }

    const locallySavedContact = this.asArray(this.locallySavedLatestContacts).find(
      (contact) =>
        this.toPositiveNumber(contact && contact.contactRevisionId) === contactRevisionIdNumber
    );

    if (locallySavedContact) {
      return true;
    }

    if (this.contacts && this.contacts.length > 0) {
      const contact = this.contacts.find(
        (x) => this.toPositiveNumber(x && x.contactRevisionId) === contactRevisionIdNumber
      );

      if (contact) {
        return true;
      }
    }
    return false;
  }

  companyDialogCancelButtonClicked() {
    if (this.companyDetailsComponent) {
      this.companyDetailsComponent.companyForm.clearValidators();
    }
    this.companyDialog.hide();
  }

  contactDialogCancelButtonClicked() {
    if (this.contactComponent) {
      this.companyDetailsComponent.companyForm.clearValidators();
    }
    this.contactDialog.hide();
  }

  showContactDialog(contactRevisionId) {
    this.erForm.markAsDirty();
    this.pageLoading = true;

    if (this.contactComponent) {
      this.contactComponent.contactRevisionId = contactRevisionId;
      this.contactComponent.ngOnInit();

      this.contactComponent.contactDetailComponent.contactRevisionId =
        contactRevisionId;

      this.contactComponent.contactDetailComponent.getContactById();
      this.contactComponent.contactDetailComponent.ngOnInit();
      this.pageLoading = false;
    }
  }

  contactRetrieved(contact) {
    if (contact) {
      this.contactDialog.show();
    }
  }

  modalContact(updatedContact) {
    const contactRevisionId = updatedContact?.contactRevisionId
      ? updatedContact.contactRevisionId
      : updatedContact;

    this.setSavedContact(contactRevisionId);
  }

  setSavedContact(contactRevisionId: any) {
    if (!contactRevisionId) {
      this.contactDialogCancelButtonClicked();
      return;
    }

    this.loadSavedRegistrantContact(contactRevisionId, true);
  }

  refreshStaleFormContacts() {
    this.refreshRegistrantContactIfStale();
    this.refreshEstablishmentContactsIfStale();
  }

  refreshRegistrantContactIfStale() {
    const currentContact: any = this.formDetailData && this.formDetailData.registrantContact
      ? this.formDetailData.registrantContact
      : this.registrantContact;
    const currentRevisionId = currentContact && currentContact.contactRevisionId;

    if (!currentRevisionId) {
      return;
    }

    const currentContactId = this.toPositiveNumber(currentContact && currentContact.contactId);

    if (!currentContactId) {
      return;
    }

    const latestContact = this.asArray(this.contacts).find(
      (contact) => this.toPositiveNumber(contact && contact.contactId) === currentContactId
    );

    if (this.isContactRevisionLatest(currentRevisionId)) {
      if (this.isRegistrantContactMissingLatestDetails(currentContact, latestContact)) {
        this.loadSavedRegistrantContact(currentRevisionId, false, latestContact);
      }
      return;
    }

    const latestRevisionId = latestContact && latestContact.contactRevisionId;

    if (
      latestRevisionId &&
      this.toPositiveNumber(latestRevisionId) !== this.toPositiveNumber(currentRevisionId)
    ) {
      this.loadSavedRegistrantContact(latestRevisionId, false, latestContact);
    }
  }

  refreshEstablishmentContactsIfStale() {
    const establishments = this.asArray(
      this.formDetailData && this.formDetailData.establishments
    );

    establishments.forEach((establishment, index) => {
      const currentContact = establishment && establishment.establishmentContact;
      const currentRevisionId = currentContact && currentContact.contactRevisionId;

      if (!currentRevisionId) {
        return;
      }

      const currentContactId = this.toPositiveNumber(
        currentContact && currentContact.contactId
      );

      if (!currentContactId) {
        return;
      }

      const latestContact = this.asArray(this.contacts).find(
        (contact) =>
          this.toPositiveNumber(contact && contact.contactId) === currentContactId
      );

      if (this.isContactRevisionLatest(currentRevisionId)) {
        if (this.isRegistrantContactMissingLatestDetails(currentContact, latestContact)) {
          this.loadSavedEstablishmentContact(index, currentRevisionId, latestContact);
        }
        return;
      }

      const latestRevisionId = latestContact && latestContact.contactRevisionId;

      if (
        latestRevisionId &&
        this.toPositiveNumber(latestRevisionId) !== this.toPositiveNumber(currentRevisionId)
      ) {
        this.loadSavedEstablishmentContact(index, latestRevisionId, latestContact);
      }
    });
  }

  isRegistrantContactMissingLatestDetails(
    currentContact: any,
    latestContact: any
  ): boolean {
    if (!latestContact) {
      return false;
    }

    const currentCountry = currentContact && currentContact.country
      ? currentContact.country
      : {};

    return (
      (!currentContact.state && (latestContact.StateProvince || latestContact.countryRegion || latestContact.state)) ||
      (!currentCountry.id && latestContact.CountryId) ||
      (!currentContact.address && latestContact.streetAddress) ||
      (!currentContact.city && (latestContact.City || latestContact.city)) ||
      (!currentContact.zip && latestContact.PostalCode) ||
      (!currentContact.email && latestContact.emailAddress)
    );
  }

  loadSavedRegistrantContact(
    contactRevisionId: any,
    closeDialog: boolean,
    latestContactFallback?: any
  ) {
    this.pageLoading = true;

    this.sub = this.companyService
      .getContactById(contactRevisionId.toString())
      .subscribe(
        (data) => {
          const contactDetails = data ? data["contactDetail"] : null;
          const contactFallback = latestContactFallback || this.asArray(this.contacts).find(
            (latestContact) =>
              this.toPositiveNumber(latestContact && latestContact.contactId) ===
              this.toPositiveNumber(contactDetails && contactDetails.contactId)
          );
          const currentRegistrantContact = this.formDetailData && this.formDetailData.registrantContact
            ? this.formDetailData.registrantContact
            : this.registrantContact;
          const contact = this.mapContactDetailsToSsdpContact(
            contactDetails,
            contactFallback,
            currentRegistrantContact
          );

          if (contact.contactRevisionId) {
            this.applyRegistrantContact(contact);
            this.refreshLatestContacts();
          }

          this.pageLoading = false;
          if (closeDialog) {
            this.contactDialogCancelButtonClicked();
          }
          this.cdRef.detectChanges();
        },
        (error) => {
          this.pageLoading = false;
          if (closeDialog) {
            this.contactDialogCancelButtonClicked();
          }
          this.toastr.error(
            error && error.errorMessage ? error.errorMessage : error
          );
        }
      );
  }

  applyRegistrantContact(contact: ISSDPConctact) {
    this.registrantContactRevisionId = contact.contactRevisionId;
    this.registrantContact = contact;
    this.trackLocallySavedLatestContact(contact);

    if (this.formDetailData) {
      this.formDetailData.registrantContact = contact;
    }

    if (this.registrantCompany) {
      this.registrantCompany.contacts = [contact];
    }

    this.erForm.patchValue({
      registrantContact: contact,
      registrantContactRevisionId: contact.contactRevisionId,
    });

    this.erForm.markAsDirty();
    this.erForm.markAsTouched();
  }

  trackLocallySavedLatestContact(contact: ISSDPConctact) {
    const contactRevisionId = this.toPositiveNumber(contact && contact.contactRevisionId);

    if (!contactRevisionId) {
      return;
    }

    const contactSnapshot = {
      contactRevisionId,
      contactId: this.toPositiveNumber(contact && contact.contactId),
      contactName: contact && contact.fullName,
      emailAddress: contact && contact.email,
      streetAddress: contact && contact.address,
      City: contact && contact.city,
      PostalCode: contact && contact.zip,
      StateProvince: contact && contact.state,
      CountryId: contact && contact.country ? contact.country.id : "",
    };

    this.locallySavedLatestContacts = this.upsertLatestContactSnapshot(
      this.locallySavedLatestContacts,
      contactSnapshot
    );
    this.contacts = this.upsertLatestContactSnapshot(this.contacts, contactSnapshot);
  }

  upsertLatestContactSnapshot(contactList: any[], contactSnapshot: any): any[] {
    const contactRevisionId = this.toPositiveNumber(
      contactSnapshot && contactSnapshot.contactRevisionId
    );
    const contactId = this.toPositiveNumber(contactSnapshot && contactSnapshot.contactId);

    if (!contactRevisionId) {
      return this.asArray(contactList);
    }

    const contacts = this.asArray(contactList).slice();
    const existingContactIndex = contacts.findIndex((contact) => {
      const existingContactId = this.toPositiveNumber(contact && contact.contactId);
      const existingRevisionId = this.toPositiveNumber(contact && contact.contactRevisionId);

      return (
        (contactId && existingContactId === contactId) ||
        existingRevisionId === contactRevisionId
      );
    });

    if (existingContactIndex >= 0) {
      contacts[existingContactIndex] = Object.assign(
        {},
        contacts[existingContactIndex],
        contactSnapshot
      );
    } else {
      contacts.push(contactSnapshot);
    }

    return contacts;
  }

  syncLocallySavedLatestContacts(latestContacts: any[]) {
    const latestContactList = this.asArray(latestContacts);

    this.locallySavedLatestContacts = this.asArray(
      this.locallySavedLatestContacts
    ).filter((localContact) => {
      const localContactId = this.toPositiveNumber(localContact && localContact.contactId);
      const localRevisionId = this.toPositiveNumber(
        localContact && localContact.contactRevisionId
      );
      const serverContact = latestContactList.find(
        (contact) =>
          localContactId &&
          this.toPositiveNumber(contact && contact.contactId) === localContactId
      );
      const serverRevisionId = this.toPositiveNumber(
        serverContact && serverContact.contactRevisionId
      );

      return !serverRevisionId || serverRevisionId < localRevisionId;
    });

    this.locallySavedLatestContacts.forEach((localContact) => {
      this.contacts = this.upsertLatestContactSnapshot(this.contacts, localContact);
    });
  }

  loadSavedEstablishmentContact(
    index: number,
    contactRevisionId: any,
    latestContactFallback?: any
  ) {
    this.sub = this.companyService
      .getContactById(contactRevisionId.toString())
      .subscribe(
        (data) => {
          const contactDetails = data ? data["contactDetail"] : null;
          const contactFallback = latestContactFallback || this.asArray(this.contacts).find(
            (latestContact) =>
              this.toPositiveNumber(latestContact && latestContact.contactId) ===
              this.toPositiveNumber(contactDetails && contactDetails.contactId)
          );
          const currentContact =
            this.formDetailData &&
            this.formDetailData.establishments &&
            this.formDetailData.establishments[index]
              ? this.formDetailData.establishments[index].establishmentContact
              : null;
          const contact = this.mapContactDetailsToSsdpContact(
            contactDetails,
            contactFallback,
            currentContact
          );

          if (contact.contactRevisionId) {
            this.applyEstablishmentContact(index, contact);
          }

          this.cdRef.detectChanges();
        },
        (error) => {
          this.toastr.error(
            error && error.errorMessage ? error.errorMessage : error
          );
        }
      );
  }

  applyEstablishmentContact(index: number, contact: ISSDPConctact) {
    if (!this.formDetailData) {
      return;
    }

    this.formDetailData.establishments = this.asArray(
      this.formDetailData.establishments
    );

    if (!this.formDetailData.establishments[index]) {
      this.formDetailData.establishments[index] = new IEstablishment();
    }

    this.formDetailData.establishments[index].establishmentContact = contact;
    this.setEstabControl();
    this.erForm.markAsDirty();
    this.erForm.markAsTouched();
  }

  mapContactDetailsToSsdpContact(
    contactDetails: any,
    latestContactFallback?: any,
    currentContactFallback?: any
  ): ISSDPConctact {
    const contact = new ISSDPConctact();

    if (!contactDetails && !latestContactFallback && !currentContactFallback) {
      return contact;
    }

    const contactSource = contactDetails || {};
    const contactFallback = latestContactFallback || {};
    const currentContact = currentContactFallback || {};
    const currentCountry = currentContact.country || {};

    contact.contactRevisionId =
      contactSource.contactRevisionId || contactFallback.contactRevisionId;
    contact.contactId = contactSource.contactId || contactFallback.contactId;
    contact.firstName = contactSource.firstName || contactFallback.firstName;
    contact.lastName = contactSource.lastName || contactFallback.lastName;
    contact.fullName = `${contactSource.firstName || ""} ${
      contactSource.lastName || ""
    }`.trim() || contactFallback.contactName;
    contact.phoneArea = contactSource.dialCode;
    contact.areaCode = contactSource.areaCode;
    contact.phone = contactSource.phoneNumber;
    contact.phoneExt = contactSource.phoneExtension;
    contact.altPhoneArea = contactSource.altDialCode;
    contact.altAreaCode = contactSource.altAreaCode;
    contact.altPhone = contactSource.altPhoneNumber;
    contact.altPhoneExt = contactSource.altPhoneExtension;
    contact.email = contactSource.email || contactFallback.emailAddress || currentContact.email;
    contact.address = contactSource.address || contactFallback.streetAddress || currentContact.address;
    contact.city =
      contactSource.city ||
      contactFallback.City ||
      contactFallback.city ||
      currentContact.city;
    contact.zip = contactSource.zip || contactFallback.PostalCode || currentContact.zip;
    contact.notes = contactSource.notes || currentContact.notes;
    contact.state =
      contactSource.countryRegion ||
      contactSource.stateProvince ||
      contactSource.StateProvince ||
      contactSource.state ||
      contactFallback.StateProvince ||
      contactFallback.countryRegion ||
      contactFallback.state ||
      currentContact.state;
    contact.country = new ILLGenericKeys();
    contact.country.id = contactSource.countryId || contactFallback.CountryId || currentCountry.id
      ? (contactSource.countryId || contactFallback.CountryId || currentCountry.id).toString()
      : "";
    contact.country.label =
      contactSource.country ||
      contactSource.Country ||
      contactFallback.Country ||
      contactFallback.country ||
      currentCountry.label;
    contact.busCategory = contactSource.businessCategory || currentContact.busCategory;

    return contact;
  }

  refreshLatestContacts() {
    this.companyService.getContacts().subscribe(
      (data) => {
        if (data) {
          this.contacts = this.asArray(data["latestAvailableContactsList"]);
          this.syncLocallySavedLatestContacts(this.contacts);
          this.refreshStaleFormContacts();
        }
        this.cdRef.detectChanges();
      },
      (error) => {
        this.toastr.error(
          error && error.errorMessage ? error.errorMessage : error
        );
      }
    );
  }

  showCompanyDialog(
    type: string,
    companyRevisionId?: number,
    index?: number,
    innerIndex?: number
  ) {
    this.erForm.markAsDirty();
    this.pageLoading = true;

    this.modalCompanyType = type;
    this.modifiedCompanyOldRevisionId = companyRevisionId;
    this.estabIndex = index;
    this.importerIndex = innerIndex;

    if (companyRevisionId) {
      const companyData$ = forkJoin([
        this.companyService.getBusinessCategories(false),
        this.companyService.getCountries(),
        this.companyService.getContacts(),
        this.refDataService.GetAllBusinessOperationQualifier(),
        this.companyService.getCompanyRevisionHistory(companyRevisionId),
        this.companyService.getBusinessOperationQualifierByCompany(
          companyRevisionId.toString()
        ),
        this.companyService.getCompanyById(companyRevisionId.toString()),
        this.companyService.getNDCLabelerCodesByCompany(
          companyRevisionId.toString()
        ),
      ])
        .pipe(catchError((err) => of(err)))
        .subscribe((data) => {
          if (this.companyDetailsComponent) {
            this.companyDetailsComponent.companyData = data;
            this.companyDetailsComponent.companyRevisionId =
              companyRevisionId.toString();
            this.companyDetailsComponent.populateDataFromResolver();
            this.companyDetailsComponent.setButtons();
            this.companyDetailsComponent
              .getFormControlByName("status")
              .patchValue("Active");
            this.companyDetailsComponent.checkUserPermission();
            this.companyDetailsComponent.ngAfterViewInit();
          }

          this.pageLoading = false;
          this.companyDialog.show();
        });
    } else {
      const companyData = [];

      this.sub = this.companyService.getBusinessCategories(false).subscribe(
        (busCat) => {
          companyData[0] = busCat;

          this.sub = this.companyService.getCountries().subscribe(
            (countries) => {
              companyData[1] = countries;

              this.sub = this.companyService
                .getContacts()
                .subscribe((contacts) => {
                  companyData[2] = contacts;

                  this.refDataService
                    .GetAllBusinessOperationQualifier()
                    .subscribe(
                      (busQual) => {
                        companyData[3] = busQual;

                        if (this.companyDetailsComponent) {
                          this.companyDetailsComponent.companyData =
                            companyData;
                          this.companyDetailsComponent.companyRevisionId = "";
                          this.companyDetailsComponent.company = null;
                          this.companyDetailsComponent.companyHistory_grid_data =
                            [];
                          this.companyDetailsComponent.populateDataFromResolver();
                          this.companyDetailsComponent.setButtons();
                          this.companyDetailsComponent.checkUserPermission();
                        }

                        this.pageLoading = false;
                        this.companyDialog.show();
                      },
                      (error) => {
                        this.toastr.error(error.message);
                        this.pageLoading = false;
                      }
                    );
                });
            },
            (error) => {
              this.toastr.error(error.message);
              this.pageLoading = false;
            }
          );
        },
        (error) => {
          this.toastr.error(error.message);
          this.pageLoading = false;
        }
      );
    }
  }

  modalCompany(newCompany) {
    switch (this.modalCompanyType) {
      case "registrants":
        this.setSavedRegistrantCompany(newCompany.companyRevisionId);
        break;
      case "establishments":
        this.setSavedEstabCompany(newCompany.companyRevisionId);
        break;
      case "usAgents":
        this.setSavedUSAgentCompany(newCompany.companyRevisionId);
        break;
      case "importers":
        this.setSavedImportersCompany(newCompany.companyRevisionId);
        break;
    }

    this.companyDialogCancelButtonClicked();
  }
  setSavedImportersCompany(companyRevisionId: any) {
    let contact;
    let estabFormGroup;
    let company;
    let importerFormGroup;

    this.sub = this.llService
      .getLCompanyTypesByCustomerGuid(this.customerGuid)
      .subscribe(
        (response) => {
          if (this.modifiedCompanyOldRevisionId) {
            const companyTypes = response["data"];

            this.formData[2].data = companyTypes;
            this.estabImporterCompanies = this.asArray(companyTypes["importers"]);

            company = this.findByNumericId(
              this.estabImporterCompanies,
              companyRevisionId,
              "companyRevisionId"
            );

            if (company) {
              if (this.estabFormControls && this.estabFormControls.length) {
                estabFormGroup = this.estabFormControls[
                  this.estabIndex
                ] as UntypedFormGroup;

                importerFormGroup = estabFormGroup.get("importers").controls[
                  this.importerIndex
                ] as UntypedFormGroup;

                if (importerFormGroup) {
                  this.estabImporterCompaniesDdwDS = [];

                  contact = this.getFirstContact(company);

                  importerFormGroup.patchValue({
                    importerCompany: company,
                    importerCompanyRevisionId: companyRevisionId,
                    importerContact: contact,
                  });

                  estabFormGroup.get("importers").controls[this.importerIndex] =
                    importerFormGroup;
                  this.estabs.controls[this.estabIndex] = estabFormGroup;

                  this.setEstabControl(this.estabs);

                  if (
                    this.estabImporterCompanies &&
                    this.estabImporterCompanies.length
                  ) {
                    this.estabImporterCompanies.forEach((estab: ILLCompany) => {
                      if (!this.toPositiveNumber(estab && estab.companyRevisionId)) {
                        return;
                      }
                      const ds = { id: 0, name: "" };
                      ds.id = +estab.companyRevisionId;
                      ds.name = `${estab.companyName || ""}`;
                      this.estabImporterCompaniesDdwDS.push(ds);
                    });
                  }

                  //this.estabImporterCompaniesDdwDS.sort(this.compare);

                  this.cdRef.detectChanges();
                }
              }
            }
          }
        },
        (error) => {
          this.toastr.error(error.message);
          this.pageLoading = false;
        }
      );
  }
  setSavedUSAgentCompany(companyRevisionId: any) {
    let contact;
    let estabFormGroup;
    let company;
    let estabFormGroupIndex;

    this.sub = this.llService
      .getLCompanyTypesByCustomerGuid(this.customerGuid)
      .subscribe(
        (response) => {
          if (this.modifiedCompanyOldRevisionId) {
            const companyTypes = response["data"];

            this.formData[2].data = companyTypes;
            this.estabUsAgentCompanies = this.asArray(companyTypes["usAgents"]);

            company = this.findByNumericId(
              this.estabUsAgentCompanies,
              companyRevisionId,
              "companyRevisionId"
            );

            if (company) {
              if (this.estabFormControls && this.estabFormControls.length) {
                estabFormGroup = this.estabFormControls.find(
                  (c) =>
                    c.value.usAgentCompanyRevisionId ===
                    this.modifiedCompanyOldRevisionId
                ) as UntypedFormGroup;

                estabFormGroupIndex = this.estabFormControls.findIndex(
                  (c) =>
                    c.value.usAgentCompanyRevisionId ===
                    this.modifiedCompanyOldRevisionId
                );

                if (estabFormGroup) {
                  this.estabUsAgentCompaniesDdwDS = [];

                  contact = this.getFirstContact(company);

                  estabFormGroup.patchValue({
                    usAgentCompany: company,
                    usAgentCompanyRevisionId: companyRevisionId,
                    usAgentContact: contact,
                  });

                  this.estabs[estabFormGroupIndex] = estabFormGroup;

                  this.setEstabControl(this.estabs);

                  if (
                    this.estabUsAgentCompanies &&
                    this.estabUsAgentCompanies.length
                  ) {
                    this.estabUsAgentCompanies.forEach(
                      (usagent: ILLCompany) => {
                        if (!this.toPositiveNumber(usagent && usagent.companyRevisionId)) {
                          return;
                        }
                        const ds = { id: 0, name: "" };
                        ds.id = +usagent.companyRevisionId;
                        ds.name = usagent.companyName || "";
                        this.estabUsAgentCompaniesDdwDS.push(ds);
                      }
                    );
                  }

                  //this.estabUsAgentCompaniesDdwDS.sort(this.compare);

                  this.cdRef.detectChanges();
                }
              }
            }
          }
        },
        (error) => {
          this.toastr.error(error.message);
          this.pageLoading = false;
        }
      );
  }

  setSavedEstabCompany(companyRevisionId: any) {
    let contact;
    let estabFormGroup;
    let company;
    let estabFormGroupIndex;

    this.sub = this.llService
      .getLCompanyTypesByCustomerGuid(this.customerGuid)
      .subscribe(
        (response) => {
          if (this.modifiedCompanyOldRevisionId) {
            const companyTypes = response["data"];

            this.formData[2].data = companyTypes;
            this.estabCompanies = this.asArray(companyTypes["establishments"]);

            company = this.estabCompanies.find(
              (c) =>
                this.toPositiveNumber(c && c.establishmentCompany && c.establishmentCompany.companyRevisionId) ===
                this.toPositiveNumber(companyRevisionId)
            );

            if (company) {
              if (this.estabFormControls && this.estabFormControls.length) {
                estabFormGroup = this.estabFormControls.find(
                  (c) =>
                    c.value.estabCompanyRevisionId ===
                    this.modifiedCompanyOldRevisionId
                ) as UntypedFormGroup;

                estabFormGroupIndex = this.estabFormControls.findIndex(
                  (c) =>
                    c.value.estabCompanyRevisionId ===
                    this.modifiedCompanyOldRevisionId
                );

                if (estabFormGroup) {
                  this.estabCompaniesDdwDS = [];

                  if (
                    company.establishmentCompany
                  ) {
                    contact = this.getFirstContact(company.establishmentCompany);
                  }

                  estabFormGroup.patchValue({
                    establishmentCompany: company.establishmentCompany,
                    estabCompanyRevisionId: companyRevisionId,
                    establishmentContact: contact,
                    establishmenName: company.establishmentCompany.companyName || "",
                  });

                  this.estabs[estabFormGroupIndex] = estabFormGroup;

                  this.setEstabControl(this.estabs);

                  if (this.estabCompanies && this.estabCompanies.length) {
                    this.estabCompanies.forEach((estab: ILLEstablishment) => {
                      if (
                        !estab ||
                        !estab.establishmentCompany ||
                        !this.toPositiveNumber(estab.establishmentCompany.companyRevisionId)
                      ) {
                        return;
                      }
                      const ds = { id: 0, name: "" };
                      ds.id = +estab.establishmentCompany.companyRevisionId;
                      ds.name = estab.establishmentCompany.companyName || "";
                      this.estabCompaniesDdwDS.push(ds);
                    });
                  }

                  //this.estabCompaniesDdwDS.sort(this.compare);

                  this.cdRef.detectChanges();
                }
              }
            }
          }
        },
        (error) => {
          this.toastr.error(error.message);
          this.pageLoading = false;
        }
      );
  }

  setSavedRegistrantCompany(companyRevisionId: any) {
    let contact;
    let company;

    this.sub = this.llService
      .getLCompanyTypesByCustomerGuid(this.customerGuid)
      .subscribe(
        (response) => {
          const companyTypes = response["data"];

          this.formData[2].data = companyTypes;
          this.registrantCompanies = this.asArray(companyTypes["registrants"]);

          company = this.findByNumericId(
            this.registrantCompanies,
            companyRevisionId,
            "companyRevisionId"
          );

          if (company) {
            this.registrantCompanyRevisionId = companyRevisionId;
            this.registrantCompany = company;

            this.registrantCompaniesDdwDS = [];

            contact = this.getFirstContact(company);
            this.registrantContactRevisionId =
              this.toPositiveNumber(contact.contactRevisionId);

            this.registrantContact = contact ? contact : new ISSDPConctact();

            this.erForm.patchValue({
              registrantCompanyRevisionId: companyRevisionId,
              registrantCompany: this.registrantCompany,
              registrantContactRevisionId: this.registrantContactRevisionId,
              formName: this.registrantCompany.companyName,
              registrantContact: contact,
            });

            if (
              this.registrantCompanies &&
              this.registrantCompanies.length > 0
            ) {
              this.registrantCompanies.forEach((comp: ILLCompany) => {
                if (!this.toPositiveNumber(comp && comp.companyRevisionId)) {
                  return;
                }
                const ds = { id: 0, name: "" };
                ds.id = +comp.companyRevisionId;
                ds.name = `${comp.companyName || ""} (${comp.dunsNumber || ""})`;
                this.registrantCompaniesDdwDS.push(ds);
              });
            }

            //this.registrantCompaniesDdwDS.sort(this.compare);

            this.registrantDdw.dataSource = this.registrantCompaniesDdwDS;
            this.registrantDdw.dataBind();
            this.registrantDdw.refresh();

            this.registrantDdw.value = companyRevisionId;
          }
          this.cdRef.detectChanges();
        },
        (error) => {
          this.toastr.error(error.message);
          this.pageLoading = false;
        }
      );
  }

  compare(a, b) {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.bame) {
      return 1;
    }
    return 0;
  }

  showToolTip(event) {
    if (this.isEllipsisActive(event)) {
      event.target.setAttribute("title", event.target.textContent);
    }
  }

  showSFToolTip(event) {
    if (this.isEllipsisActive(event)) {
      if (this.tooltipObj) {
        this.tooltipObj.content = event.target.outerText;
        this.tooltipObj.width = `${event.target.scrollWidth}px`;

        this.tooltipObj.open();
      }
    }
  }

  hideSFToolTip(event) {
    if (this.tooltipObj) {
      this.tooltipObj.close();
    }
  }

  hideToolTip(event) {
    event.target.removeAttribute("title");
  }

  isEllipsisActive(e) {
    return e.target.offsetWidth < e.target.scrollWidth;
  }

  missingCompanyRevisionId(companyType, index: number, innerIndex?: number) {
    let companyRevisionId;

    if (index >= 0) {
      if (this.estabs && this.estabs.length) {
        const estabControl = this.estabs.controls[index];
        if (!estabControl) {
          return true;
        }

        switch (companyType.toLowerCase()) {
          case "establishments":
            companyRevisionId =
              estabControl.value.establishmentCompany
                ? estabControl.value.establishmentCompany.companyRevisionId
                : 0;
            break;
          case "usagents":
            companyRevisionId =
              estabControl.value.usAgentCompanyRevisionId;
            break;
          case "importers":
            const importerControl = this.importersArray(index).controls[innerIndex];
            companyRevisionId = importerControl
              ? importerControl.value.importerCompanyRevisionId
              : 0;
            break;
        }

        if (!companyRevisionId) {
          //   this.validationMessages.missingCompanyRevisionId.required = companyType === 'establishments' ? 'Missing Establishment company' : companyType === 'usagents' ? 'Missing US Agent company' : 'Missing Importer company';
          this.validationMessages.missingCompanyRevisionId.required =
            companyType === "establishments"
              ? "Missing Establishment company"
              : companyType === "usagents"
              ? "Missing US Agent company"
              : "";

          this.formErrors.missingCompanyRevisionId =
            this.validationMessages.missingCompanyRevisionId.required;

          return true;
        }
      }
    }
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
    this.utilService.toggleClientDropdownState(false);
  }
}
